/*
 * Drive the coast: turns the stacked stops into a scroll-driven drive. No library.
 * Does nothing when the visitor asks for reduced motion: the stops stay as plain stacked sections.
 * Keyboard: focusing a link in a stop scrolls to that stop, so tabbing drives the road too.
 * Justified in docs/decisions-log.md (2026-09-22).
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(drive) {
    if (drive.dataset.driveReady || reduce.matches) return;
    var stage = drive.querySelector('[data-drive-stage]');
    var stops = Array.prototype.slice.call(drive.querySelectorAll('[data-stop]'));
    var road = drive.querySelector('[data-drive-road]');
    var car = drive.querySelector('[data-drive-car]');
    if (!stage || stops.length < 2) return;
    drive.dataset.driveReady = '1';
    drive.classList.add('is-driving');

    // Horizon scrolls .page-wrapper, not the window, on wide screens: follow whichever scrolls
    var sc = null;
    for (var el = drive.parentElement; el && el !== document.body; el = el.parentElement) {
      var o = getComputedStyle(el).overflowY;
      if (o === 'auto' || o === 'scroll') {
        sc = el;
        break;
      }
    }
    function scrollTop() {
      return sc ? sc.scrollTop : window.scrollY;
    }
    function viewTop() {
      return sc ? sc.getBoundingClientRect().top : 0;
    }

    var len = 0;
    try {
      len = road.getTotalLength();
    } catch (e) {}
    var cur = -1;
    var ticking = false;

    function setStop(i) {
      if (i === cur) return;
      cur = i;
      var s = stops[i];
      stage.style.setProperty('--field', s.getAttribute('data-field'));
      stage.style.setProperty('--ink', s.getAttribute('data-ink'));
      stops.forEach(function (el, n) {
        el.classList.toggle('is-active', n === i);
      });
    }

    // Measured against the sticky stage (100svh, steady), not innerHeight: on iPhone Safari innerHeight
    // changes as the toolbars show and hide mid-scroll, which made the progress jump and the stop flicker
    function progress() {
      var r = drive.getBoundingClientRect();
      var span = r.height - stage.offsetHeight;
      return span > 0 ? Math.min(1, Math.max(0, (viewTop() - r.top) / span)) : 0;
    }

    // A small dead band at each boundary, so a stop does not flip back and forth (and replay its signs)
    // while a finger rests near the edge between two stops
    function stopAt(p) {
      var x = p * stops.length;
      var i = Math.min(stops.length - 1, Math.floor(x));
      if (Math.abs(i - cur) === 1 && Math.abs(x - Math.max(i, cur)) < 0.06) return cur;
      return i;
    }

    function update() {
      ticking = false;
      var p = progress();
      var at = 0.08 + p * 0.92;
      if (road) road.style.strokeDashoffset = (1 - at).toFixed(4);
      if (len && car) {
        var pt = road.getPointAtLength(len * at);
        car.setAttribute('cx', pt.x);
        car.setAttribute('cy', pt.y);
      }
      setStop(stopAt(p));
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function goTo(i) {
      var top = drive.getBoundingClientRect().top - viewTop() + scrollTop();
      var span = drive.offsetHeight - stage.offsetHeight;
      (sc || window).scrollTo(0, top + span * ((i + 0.5) / stops.length));
    }

    drive.addEventListener('focusin', function (e) {
      var i = stops.indexOf(e.target.closest('[data-stop]'));
      if (i >= 0 && i !== cur) goTo(i);
    });

    // A link to one stop (#drive-stop-3) lands on that stop of the drive
    function fromHash() {
      var i = stops.map(function (s) { return '#' + s.id; }).indexOf(location.hash);
      if (i >= 0) goTo(i);
    }
    window.addEventListener('hashchange', fromHash);

    (sc || window).addEventListener('scroll', onScroll, { passive: true });
    if (sc) window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    fromHash();
    update();
  }

  function run() {
    document.querySelectorAll('[data-drive]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
